import { reducerFromMap } from "../../libs/helpers/reducers";

import {
  MEDIUM_PLANNING_LOADING,
  MEDIUM_PLANNING_LOADED,
  MEDIUM_PLANNING_LOAD_ERROR,
  MEDIUM_PLANNING_CREATE_LOADING,
  MEDIUM_PLANNING_CREATE_LOAD_ERROR,
  MEDIUM_PLANNING_EDIT_LOADING,
  MEDIUM_PLANNING_EDIT_COMPLETE,
  MEDIUM_PLANNING_EDIT_LOAD_ERROR,
  MEDIUM_PLANNING_DELETE_LOADING,
  MEDIUM_PLANNING_DELETE_COMPLETE,
  MEDIUM_PLANNING_DELETE_LOAD_ERROR,
  MEDIUM_PLANNING_CREATE_COMPLETE,
} from "../../actions/registry/registry.medium_planning.actions";

const reducer = {
  /*
   * MEDIUM_PLANNING LIST
   */
  [MEDIUM_PLANNING_LOADING]: (state) => ({
    ...state,
    loading: true,
  }),
  [MEDIUM_PLANNING_LOADED]: (state, { data }) => ({
    ...state,
    loading: false,
    data: data.data,
  }),
  [MEDIUM_PLANNING_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    loading: false,
    error: data,
  }),
  /*
   * MEDIUM_PLANNING CREATE
   */
  [MEDIUM_PLANNING_CREATE_LOADING]: (state) => ({
    ...state,
    loading: true,
  }),
  [MEDIUM_PLANNING_CREATE_COMPLETE]: (state, { data }) => ({
    ...state,
    loading: false,
  }),
  [MEDIUM_PLANNING_CREATE_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    loading: false,
    error: data,
  }),
  /*
   * MEDIUM_PLANNING EDIT
   */
  [MEDIUM_PLANNING_EDIT_LOADING]: (state) => ({
    ...state,
    loading: true,
  }),
  [MEDIUM_PLANNING_EDIT_COMPLETE]: (state, { data }) => ({
    ...state,
    loading: false,
  }),
  [MEDIUM_PLANNING_EDIT_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    loading: false,
    error: data,
  }),
  /*
   * MEDIUM_PLANNING DELETE
   */
  [MEDIUM_PLANNING_DELETE_LOADING]: (state) => ({
    ...state,
    medium_planning: { ...state.medium_planning, loading: true },
  }),
  [MEDIUM_PLANNING_DELETE_COMPLETE]: (state, { data }) => ({
    ...state,
    loading: false,
  }),
  [MEDIUM_PLANNING_DELETE_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    medium_planning: { ...state.medium_planning, loading: false },
    error: data,
  }),
};

export default reducerFromMap(reducer, {
  data: [],
});
